import { MessagingExecutionType } from './messagingExecutionType';
import { TriggerKey } from '../userCommunicationAgent';

// Teams trigger configs

export interface TeamsNewMessageTriggerConfig {
  executionType: MessagingExecutionType;
  /** Chat ids from the Graph. Empty/absent = all chats. */
  chats?: string[];
  /** Microsoft account. Absent = all connected accounts. */
  homeAccountId?: string;
  /** DEBOUNCE only. */
  debounceMinutes?: number;
}

// Teams step configs

export interface SendTeamsMessageStepConfig {
  chatId: string;
  message: string;
  /** Absent = account of the communication that fired the flow, then resolveAccount. */
  homeAccountId?: string;
}

export const TEAMS_TRIGGER_KEYS = [TriggerKey.TEAMS_NEW_MESSAGE];
